module.exports = __webpack_public_path__ + "static/media/icon-dropdown.3c6c769f.svg";